"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactVirtualized = require("react-virtualized");

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var TileCollection = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(TileCollection, _PureComponent);

  function TileCollection() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TileCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TileCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.isRowLoaded = function (_ref) {
      var index = _ref.index;
      var tiles = _this.props.tiles;
      return !_this.hasMore() || index < tiles.count();
    };

    _this.hasMore = function () {
      var _this$props = _this.props,
          tiles = _this$props.tiles,
          total = _this$props.total;
      return tiles.count() < total;
    };

    _this.getRowCount = function () {
      var tiles = _this.props.tiles;
      return _this.hasMore() ? tiles.size + 1 : tiles.size;
    };

    _this.getCellSizeAndPosition = function (_ref2) {
      var index = _ref2.index;
      var tiles = _this.props.tiles;
      var tile = tiles.get(index);
      return {
        height: tile.get('height'),
        width: tile.get('width'),
        x: tile.get('x'),
        y: tile.get('y')
      };
    };

    _this.renderCell = function (_ref3) {
      var index = _ref3.index,
          key = _ref3.key,
          style = _ref3.style;
      var _this$props2 = _this.props,
          tiles = _this$props2.tiles,
          tileRenderer = _this$props2.tileRenderer;
      var tile = tiles.get(index);
      var objectId = tile.getIn(['file', 'id']) || tile.getIn(['image', 'id']);
      return _react.default.createElement("div", {
        key: key,
        style: style,
        className: "tile-cell",
        "data-test-object-id": objectId
      }, tileRenderer(tile));
    };

    return _this;
  }

  (0, _createClass2.default)(TileCollection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          tiles = _this$props3.tiles,
          onLoadMoreFiles = _this$props3.onLoadMoreFiles,
          previousSelectedFileId = _this$props3.previousSelectedFileId;
      var scrollToCellIndex = previousSelectedFileId ? tiles.findIndex(function (t) {
        return t.getIn(['file', 'id']) === previousSelectedFileId || t.getIn(['image', 'id']) === previousSelectedFileId;
      }) : 0;
      return _react.default.createElement(_UIBox.default, {
        grow: 1,
        "data-test-id": "infinite-tiles"
      }, _react.default.createElement(_reactVirtualized.InfiniteLoader, {
        loadMoreRows: onLoadMoreFiles,
        isRowLoaded: this.isRowLoaded,
        rowCount: this.getRowCount()
      }, function (_ref4) {
        var onRowsRendered = _ref4.onRowsRendered,
            registerChild = _ref4.registerChild;
        return _react.default.createElement(_reactVirtualized.AutoSizer, null, function (_ref5) {
          var width = _ref5.width,
              height = _ref5.height;
          return _react.default.createElement(_reactVirtualized.Collection, {
            ref: registerChild,
            height: height,
            width: width,
            tiles: tiles,
            cellCount: tiles.size,
            onRowsRendered: onRowsRendered,
            cellRenderer: _this2.renderCell,
            cellSizeAndPositionGetter: _this2.getCellSizeAndPosition,
            onSectionRendered: function onSectionRendered(_ref6) {
              var indices = _ref6.indices;
              onRowsRendered({
                startIndex: indices[0],
                stopIndex: indices[indices.length - 1]
              });
            },
            verticalOverscan: 8,
            previousSelectedFileId: previousSelectedFileId,
            scrollToCell: scrollToCellIndex
          });
        });
      }));
    }
  }]);
  return TileCollection;
}(_react.PureComponent);

TileCollection.propTypes = {
  tiles: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  total: _propTypes.default.number.isRequired,
  previousSelectedFileId: _propTypes.default.number,
  tileRenderer: _propTypes.default.func.isRequired,
  onLoadMoreFiles: _propTypes.default.func.isRequired
};
var _default = TileCollection;
exports.default = _default;
module.exports = exports.default;